/* ============================================================
   GREEN KITCHEN — PRODUCT PAGE JS  v3.0  (UI UPDATE)
   File: greenkitchen-product.js
   Add to theme.liquid just before </body>:
   <script src="{{ 'greenkitchen-product.js' | asset_url }}" defer></script>

   CHANGELOG v3.0
   - FIX: Removed stray CSS at end of file that caused a JS syntax error.
   - Moved the mobile logo CSS into the injected <style> block.
   - Added extra DOM selector fallbacks for chip injection.
   - Increased init timeout from 2000ms to 3000ms for slower themes.
   - UI: Removed black border from chips container (cleaner look).
   - UI: Added "Your plan:" label above chips.
   - UI: Ensured retake quiz button is always visible.
   ============================================================ */

(function () {

  // ── READ URL PARAMS ───────────────────────────────────────
  const params      = new URLSearchParams(window.location.search);
  const duration    = params.get('duration');
  const mealType    = params.get('meal');
  const portion     = params.get('portion');
  const allergyNote = params.get('note');
  const fromQuiz    = params.get('view') === 'quiz-landing';

  // ── INJECT STYLES ─────────────────────────────────────────
  const style = document.createElement('style');
  style.textContent = `

    /* ── Center all product info sections ── */
    .product__title, h1.product__title {
      text-align: center !important;
    }
    product-info,
    .product__info-wrapper,
    .product__info-container {
      display: flex !important;
      flex-direction: column !important;
      align-items: center !important;
      text-align: center !important;
    }
    product-info > *,
    .product__info-wrapper > *,
    .product__info-container > *,
    .shopify-block,
    .product-form__input {
      text-align: center !important;
    }

    /* ── Clean high-end look: remove all section borders ── */
    .product__info-wrapper > *,
    .product__info-container > *,
    product-info > *,
    .product-form__input,
    .product-form,
    .product__info-wrapper .card,
    .product__info-container .card,
    product-info .card,
    product-info > section,
    product-info > div,
    .product__info-wrapper > section,
    .product__info-wrapper > div {
      border: none !important;
      box-shadow: none !important;
    }

    /* Remove grey borders from delivery, subscription, form sections */
    .product__info-wrapper .product-form__input,
    .product__info-container .product-form__input,
    product-info .product-form__input,
    .shopify-block,
    .product__info-wrapper .shopify-block,
    product-info .shopify-block {
      border: none !important;
      box-shadow: none !important;
      outline: none !important;
    }

    /* Remove black border from allergies/intolerances section */
    #infiniteoptions-container,
    #infiniteoptions-container > *,
    .infiniteoptions-container,
    [id*="infiniteoptions"],
    [id*="infiniteoptions"] fieldset,
    [id*="infiniteoptions"] .spb-field,
    [id*="infiniteoptions"] .spb-group {
      border: none !important;
      box-shadow: none !important;
      outline: none !important;
    }

    /* Kill ALL remaining black outlines on the product page */
    product-info *,
    .product__info-wrapper *,
    .product__info-container * {
      outline-color: transparent !important;
    }


    /* Remove borders from Recharge widget sections */
    .rc-widget,
    .rc-widget > *,
    .rc-widget__container {
      border: none !important;
      box-shadow: none !important;
    }

    /* Remove Subscription Detail border */
    .rc-subscription-details {
      border: none !important;
      box-shadow: none !important;
    }

    /* ── Quiz chips summary bar ── */
    #gk-plan-summary {
      background: transparent;
      padding: 8px 0 4px 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 6px;
      margin: 0 auto;
      text-align: center;
      border: none;
      width: 100%;
      box-sizing: border-box;
    }
    .gk-plan-label {
      font-size: 12px;
      font-weight: 600;
      color: #005940;
      text-transform: uppercase;
      letter-spacing: 0.05em;
    }
    .gk-summary-chips {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      justify-content: center;
      width: 100%;
      padding: 0;
      margin: 0;
    }
    .gk-chip {
      background: #005940 !important;
      color: #c2ed47 !important;
      font-size: 13px !important;
      font-weight: 700 !important;
      letter-spacing: 0.02em !important;
      padding: 6px 14px !important;
      border-radius: 8px !important;
      white-space: nowrap !important;
      border: none !important;
      box-shadow: none !important;
      outline: none !important;
      -webkit-appearance: none !important;
    }
    #gk-retake-quiz,
    .gk-change-btn,
    button.gk-change-btn {
      background: none !important;
      border: none !important;
      color: #888 !important;
      font-size: 12px !important;
      font-weight: 400 !important;
      padding: 0 !important;
      cursor: pointer !important;
      display: inline-block !important;
      visibility: visible !important;
      margin: 2px auto 0 !important;
      opacity: 1 !important;
      text-decoration: underline !important;
      line-height: normal !important;
      -webkit-appearance: none !important;
      border-radius: 0 !important;
    }
    #gk-retake-quiz:hover,
    .gk-change-btn:hover { color: #005940 !important; }

    /* ── Quiz CTA bar ── */
    #gk-quiz-cta {
      background: #005940;
      border-radius: 8px;
      padding: 16px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 12px;
      text-align: center;
      margin: 0;
    }
    .gk-cta-text {
      color: rgba(255,255,255,0.9);
      font-size: 14px;
      font-weight: 500;
    }
    .gk-cta-btn {
      background: #c2ed47;
      border: none;
      color: #003326;
      font-size: 13px;
      font-weight: 700;
      letter-spacing: 0.02em;
      padding: 8px 18px;
      border-radius: 8px;
      cursor: pointer;
      white-space: nowrap;
      transition: opacity 0.2s;
    }
    .gk-cta-btn:hover { opacity: 0.85; }

    /* ── Trust bar ── */
    #gk-trust-bar {
      display: none !important;
    }

    /* ── Start your plan button ── */
    .product-form__cart-submit,
    button[name="add"] {
      background: #005940 !important;
      color: #c2ed47 !important;
      border: none !important;
      border-radius: 8px !important;
    }

    /* ── Recharge subscription toggle ── */
    .rc-radio__label {
      border: none !important;
      border-radius: 8px !important;
      padding: 12px 8px !important;
      text-align: center !important;
      cursor: pointer !important;
      transition: background 0.2s, color 0.2s !important;
    }
    .rc-radio__input--hidden:checked + .rc-radio__label {
      background: #005940 !important;
    }
    .rc-radio__input--hidden:checked + .rc-radio__label *,
    .rc-radio__input--hidden:checked + .rc-radio__label .rc-radio__label-text,
    .rc-radio__input--hidden:checked + .rc-radio__label .rc-option__price,
    .rc-radio__input--hidden:checked + .rc-radio__label .rc-option__discount {
      color: #c2ed47 !important;
    }
    .rc-radio__input--hidden:not(:checked) + .rc-radio__label {
      background: #6B1F5C !important;
      opacity: 0.45 !important;
    }
    .rc-radio__input--hidden:not(:checked) + .rc-radio__label *,
    .rc-radio__input--hidden:not(:checked) + .rc-radio__label .rc-radio__label-text,
    .rc-radio__input--hidden:not(:checked) + .rc-radio__label .rc-option__price,
    .rc-radio__input--hidden:not(:checked) + .rc-radio__label .rc-option__discount {
      color: #c2ed47 !important;
    }
    .discount-label { color: #c2ed47 !important; }
    .rc-subscription-details {
      border: none !important;
      border-radius: 8px !important;
      color: #005940 !important;
      margin-top: 8px !important;
    }

 /* ── Infinite Options — remove left border, tighten spacing ── */
    #infiniteoptions-container {
      border-color: white !important;
      box-shadow: none !important;
      outline: none !important;
      margin: 0 !important;
      padding-top: 12px !important;
      padding-bottom: 12px !important;
    }
    #infiniteoptions-container .spb-label-tooltip {
      color: #222222 !important;
      font-size: 13px !important;
      font-weight: 600 !important;
      text-transform: none !important;
      letter-spacing: 0 !important;
      font-family: inherit !important;
    }
    #infiniteoptions-container .spb-label-tooltip::before {
      display: none !important;
    }

    /* ── Remove theme card padding around Infinite Options ── */
    .product-form__input:has(#infiniteoptions-container) {
      padding: 0 !important;
      margin: 0 !important;
      border-color: white !important;
      box-shadow: none !important;
    }
    product-form > div:has(#infiniteoptions-container),
    .product-form > div:has(#infiniteoptions-container) {
      padding: 0 !important;
      margin: 0 !important;
      border-color: white !important;
      box-shadow: none !important;
    }

    /* ── Tighten all product form block gaps ── */
    product-form .product-form__input,
    .product-form .product-form__input {
      margin-top: 0 !important;
      margin-bottom: 0 !important;
      padding-top: 0 !important;
      padding-bottom: 0 !important;
    }

    /* ── Fix logo size on mobile (was incorrectly outside JS) ── */
    @media screen and (max-width: 749px) {
      .header__heading-logo {
        max-width: 120px !important;
        width: auto !important;
        height: auto !important;
      }
      .header__heading-logo-wrapper {
        max-width: 120px !important;
      }
  `;
  document.head.appendChild(style);

  // ── PLAN PRODUCT DETECTION ────────────────────────────────
  function isKnownPlanProduct() {
    var handle = window.GK_CURRENT_PRODUCT || '';
    if (!handle) return false;
    var patterns = [
      'balanced-meal-plan-high-protein',
      'pescatarian-meal-plan-high-quality',
      'vegetarian-meal-plan-fresh-balanced',
      'vegan-meal-plan-nutrient-dense',
      'monthly', 'prepaid', '4-week',
      'wellness', '8-week', 'healthy-eating-program'
    ];
    return patterns.some(function(p) { return handle.includes(p); });
  }

  // ── MAIN INIT ─────────────────────────────────────────────
  function init() {
    console.log('[GK Product] init() running — fromQuiz:', fromQuiz,
      'duration:', duration, 'meal:', mealType, 'portion:', portion);

    if (duration || mealType || portion) preSelectVariants();
    if (fromQuiz) document.body.classList.add('gk-from-quiz');
    if (duration || mealType || portion) {
      injectSummaryBar();
    } else if (document.getElementById('quizOverlay') && isKnownPlanProduct()) {
      injectQuizCTA();
    }
    injectTrustBar();
    cleanAllergyLabels();
    if (allergyNote) passAllergyNote(allergyNote);
  }

  // ── PRE-SELECT VARIANTS ───────────────────────────────────
  function preSelectVariants() {
    document.querySelectorAll('.product-form__input input[type="radio"]').forEach(input => {
      const fieldset = input.closest('fieldset, .product-form__input');
      const legend   = fieldset?.querySelector('legend, .form__label')?.textContent?.trim()?.toLowerCase() || '';
      const val      = input.value?.trim()?.toLowerCase();
      let target = null;
      if (legend.includes('duration') && duration)                               target = duration.toLowerCase();
      if ((legend.includes('meal') || legend.includes('plan type')) && mealType) target = mealType.toLowerCase();
      if (legend.includes('portion') && portion)                                 target = portion.toLowerCase();
      if (target && val === target) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    document.querySelectorAll('.product-form__input select').forEach(select => {
      const labelEl = select.closest('.product-form__input')
        ?.querySelector('.form__label, .product-form__info-title, label');
      const name = labelEl?.textContent?.trim()?.toLowerCase() || '';
      let target = null;
      if (name.includes('duration') && duration)                               target = duration;
      if ((name.includes('meal') || name.includes('plan type')) && mealType)   target = mealType;
      if (name.includes('portion') && portion)                                 target = portion;
      if (target) {
        const option = Array.from(select.options)
          .find(o => o.text.trim().toLowerCase() === target.toLowerCase());
        if (option) {
          select.value = option.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  }

  // ── FIND PRODUCT INFO CONTAINER ───────────────────────────
  // Shared helper so both injectSummaryBar and injectQuizCTA
  // use the same (expanded) list of selectors.
  function findProductInfo() {
    return (
      document.querySelector('product-info') ||
      document.querySelector('.product__info-container') ||
      document.querySelector('.product__info-wrapper') ||
      document.querySelector('[id*="product-info"]') ||
      document.querySelector('[id*="ProductInfo"]') ||
      document.querySelector('.product-info') ||
      document.querySelector('.product__column-sticky') ||
      document.querySelector('.product-single__meta') ||
      document.querySelector('section.product') ||
      document.querySelector('[data-product-info]')
    );
  }

  // ── INJECT SUMMARY BAR ───────────────────────────────────
  function injectSummaryBar() {
    if (document.getElementById('gk-plan-summary')) return;

    const dLabel = duration || getSelectedOption('duration');
    const mLabel = mealType || getSelectedOption('meal');
    const pLabel = portion  || getSelectedOption('portion');

    const chips = [dLabel, mLabel, pLabel]
      .filter(Boolean)
      .map(l => `<span class="gk-chip">${l}</span>`)
      .join('');

    if (!chips) return;

    const bar = document.createElement('div');
    bar.id = 'gk-plan-summary';
    bar.innerHTML = `
      <span class="gk-plan-label">Your plan:</span>
      <div class="gk-summary-chips">${chips}</div>
      <button class="gk-change-btn" id="gk-retake-quiz" type="button">Redo quiz</button>
    `;

    const productInfo = findProductInfo();
    const titleBlock = productInfo?.querySelector('.product__title, h1');

    console.log('[GK Product] injectSummaryBar — productInfo:', productInfo,
      'titleBlock:', titleBlock);

    if (productInfo && titleBlock) {
      const after = titleBlock.nextSibling;
      productInfo.insertBefore(bar, after);
    } else if (productInfo) {
      productInfo.insertBefore(bar, productInfo.firstChild);
    } else {
      // Ultimate fallback: find ANY h1 on the page
      const h1 = document.querySelector('h1.product__title, .product__title, h1');
      if (h1) {
        h1.parentNode.insertBefore(bar, h1.nextSibling);
      } else {
        // Last resort: prepend to main content
        const main = document.querySelector('main, #MainContent, .main-content');
        if (main) main.prepend(bar);
      }
    }

    document.getElementById('gk-retake-quiz')?.addEventListener('click', () => {
      if (typeof openQuiz === 'function') {
        openQuiz();
      } else {
        window.location.href = '/?openQuiz=true';
      }
    });
  }

  // ── INJECT QUIZ CTA BAR ──────────────────────────────────
  function injectQuizCTA() {
    if (document.getElementById('gk-quiz-cta')) return;

    const bar = document.createElement('div');
    bar.id = 'gk-quiz-cta';
    bar.innerHTML = `
      <span class="gk-cta-text">No plan chosen yet — answer a few quick questions to find your fit.</span>
      <button class="gk-cta-btn" id="gk-open-quiz" type="button">Choose my plan →</button>
    `;

    const productInfo = findProductInfo();
    const titleBlock = productInfo?.querySelector('.product__title');

    if (productInfo && titleBlock) {
      const after = titleBlock.nextSibling;
      productInfo.insertBefore(bar, after);
    } else if (productInfo) {
      productInfo.insertBefore(bar, productInfo.firstChild);
    }

    document.getElementById('gk-open-quiz')?.addEventListener('click', () => {
      if (typeof openQuiz === 'function') {
        openQuiz();
      } else {
        window.location.href = window.location.pathname + '?openQuiz=true';
      }
    });
  }

  // ── INJECT TRUST BAR ─────────────────────────────────────
  function injectTrustBar() {
    if (document.getElementById('gk-trust-bar')) return;

    const addToCartBtn =
      document.querySelector('.product-form__cart-submit') ||
      document.querySelector('button[name="add"]');

    if (!addToCartBtn) return;

    const trustBar = document.createElement('div');
    trustBar.id = 'gk-trust-bar';
    trustBar.innerHTML = `
      <div class="gk-trust-item"><span class="gk-trust-dot"></span>Free delivery island-wide</div>
      <div class="gk-trust-item"><span class="gk-trust-dot"></span>Cancel anytime</div>
      <div class="gk-trust-item"><span class="gk-trust-dot"></span>Cut-off Friday 10pm</div>
      <div class="gk-trust-item"><span class="gk-trust-dot"></span>Starts Sunday PM or Monday AM</div>
    `;

    addToCartBtn.parentNode.insertBefore(trustBar, addToCartBtn.nextSibling);
  }

  // ── PASS ALLERGY NOTE ─────────────────────────────────────
  function passAllergyNote(note) {
    const form =
      document.querySelector('form[action="/cart/add"]') ||
      document.querySelector('.product-form form');
    if (!form) return;

    const existing = form.querySelector('input[name="properties[Allergies/Intolerances]"]');
    if (existing) { existing.value = note; return; }

    const hidden = document.createElement('input');
    hidden.type  = 'hidden';
    hidden.name  = 'properties[Allergies/Intolerances]';
    hidden.value = note.replace('Allergies/Intolerances: ', '');
    form.appendChild(hidden);
  }

  // ── CLEAN ALLERGY LABELS ──────────────────────────────────
  function cleanAllergyLabels() {
    const container = document.getElementById('infiniteoptions-container');
    if (!container) return;

    container.querySelectorAll('.spb-label-tooltip').forEach(tooltip => {
      Array.from(tooltip.childNodes).forEach(node => {
        if (node.nodeType === 3 && node.textContent.trim().length > 40) {
          node.textContent = '';
        }
        if (node.nodeType === 1) {
          const text = node.textContent.trim().toLowerCase();
          if (text.includes('please select') ||
              text.includes('personal meal') ||
              text.includes('for more than')) {
            node.style.display = 'none';
          }
        }
      });
    });
  }

  // ── HELPER ────────────────────────────────────────────────
  function getSelectedOption(optionName) {
    const selects = document.querySelectorAll('.product-form__input select');
    for (const select of selects) {
      const label = select.closest('.product-form__input')
        ?.querySelector('.form__label, .product-form__info-title, label')
        ?.textContent?.trim()?.toLowerCase() || '';
      if (label.includes(optionName.toLowerCase())) {
        return select.options[select.selectedIndex]?.text?.trim();
      }
    }
    return null;
  }

  // ── RUN ───────────────────────────────────────────────────
  // Try to run as soon as we can find the product title on the page.
  // Check every 200ms up to 10 times (2 seconds max), then give up gracefully.
  function waitForProductInfo() {
    let attempts = 0;
    const maxAttempts = 10;
    const check = () => {
      attempts++;
      const ready = findProductInfo() || document.querySelector('h1');
      if (ready) {
        init();
      } else if (attempts < maxAttempts) {
        setTimeout(check, 200);
      } else {
        // Fallback: run anyway after 2s even if we can't find the container
        init();
      }
    };
    check();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForProductInfo);
  } else {
    waitForProductInfo();
  }

})();
/* END OF FILE — no code below this line */